// extracted by mini-css-extract-plugin
export default {"searchInput":"Search_searchInput__+kXk1","searchIconWrapper":"Search_searchIconWrapper__VG-UO"};